import { ChatUserModel } from 'types/chat-users/chat-user';

/**
 * מפה בין שדות מ-ChatUserModel לשדות ב-API החדש
 */
export const fieldMapping: Partial<Record<keyof ChatUserModel, string>> = {
  // מורשת: תצוגות ישנות שנשמרו עם IsOpen (פתוחה/סגורה). הבורר כבר לא מציע את
  // השדה — סטטוס הפלואו החליף אותו — והתצוגות השמורות מומרות ב-DB לפלואו 1-5/6.
  // המיפוי נשאר רק כדי שתצוגה שטרם הומרה תמשיך לעבוד (המנוע בשרת עוד פותר אותו).
  IsOpen: 'lastSession.status',
UnreadMessagesNumber: 'unreadCount',
  UnreadNumber: 'unreadCount',
  LastMessage: 'lastMessageObject.message',
  LastMessageDate: 'lastMessageObject.dateCreated',
  LastMessageMediaType: 'lastMessageObject.type',
  LastMessageSource: 'lastMessageObject.status',
  LastMessageType: 'lastMessageObject.direction',
  IncomingLastMessage: 'lastIncomingMessage.message',
  IncomingLastMessageDate: 'lastIncomingMessage.dateCreated',
  IncomingLastMessageMediaType: 'lastIncomingMessage.type',
  IncomingLastMessageSource: 'lastIncomingMessage.status',
  OutcomingLastMessage: 'lastOutgoingMessage.message',
  OutcomingLastMessageDate: 'lastOutgoingMessage.dateCreated',
  OutcomingLastMessageStatus: 'lastOutgoingMessage.status',
  OutgoingLastMessageMediaType: 'lastOutgoingMessage.type',
  FullName: 'name',
  UserDisplayPhoneNumber: 'phone',
  Email: 'email',
  UserPic: 'pic',
  isBot: 'activeBot', // זה מיוחד - צריך לבדוק אם activeBot isnotnull
  isRestricted24: 'isWhatsappWindowOpen', // מיפוי ל-API: isRestricted24 בקוד → isWhatsappWindowOpen ב-API
  OpenTime: 'lastSession.dateStart',
  snoozeEndTime: 'lastSession.snoozeEndTime',
  AccountPowerlinkId: 'fireberryId',
  ContactPowerlinkId: 'fireberryId',
  ObjectPowerlinkId: 'fireberryId',
  fireberryAccountLink: 'fireberryId',
};

/**
 * ממיר שדה מ-ChatUserModel לשדה ב-API
 * מטפל גם בשדות From/To שמתמפים לשדות הבסיסיים
 * מטפל גם בשדות חדשים עם נתיבים מלאים (למשל lastSession.dateStart)
 */
export function mapFieldToApiField(field: keyof ChatUserModel | string): string {
  // אם השדה כבר במפה, החזר אותו
  if (fieldMapping[field as keyof ChatUserModel]) {
    return fieldMapping[field as keyof ChatUserModel]!;
  }
  
  // טיפול בשדות From/To שלא קיימים ב-ChatUserModel אבל קיימים ב-filterOptions
  if (field === 'OutcomingLastMessageDateFrom' || field === 'OutcomingLastMessageDateTo') {
    return 'lastOutgoingMessage.dateCreated';
  }
  
  if (field === 'IncomingLastMessageDateFrom' || field === 'IncomingLastMessageDateTo') {
    return 'lastIncomingMessage.dateCreated';
  }
  
  if (field === 'IsOpenUpdateTimeFrom' || field === 'IsOpenUpdateTimeTo') {
    return 'lastSession.dateStart';
  }
  
  // אם השדה כבר בנתיב מלא (למשל lastSession.dateStart, lastMessageObject.id), החזר אותו כמו שהוא
  // אבל יש יוצא דופן: lastSession.manager.id צריך להיות managerId
  if (field === 'lastSession.manager.id') {
    return 'managerId';
  }
  
  if (typeof field === 'string' && (field.includes('.') || 
      field.startsWith('lastSession.') || 
      field.startsWith('lastMessageObject.') || 
      field.startsWith('lastIncomingMessage.') || 
      field.startsWith('lastOutgoingMessage.'))) {
    return field;
  }
  
  // אם זה לא שדה מ-ChatUserModel, נחזיר אותו כמו שהוא (יכול להיות שדה ישירות מ-API)
  return field;
}

/**
 * בודק אם שדה הוא FilterGroup (מבנה חדש)
 */
export function isFilterGroup(filter: any): filter is import('types/userConfig/userConfig').FilterGroup {
  return filter && Array.isArray(filter.conditions) && filter.conditions.length > 0 && filter.conditions[0].hasOwnProperty('operator');
}

